import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';

interface CompareRemarkProps {
  /**
   * The title of the remark section.
   */
  title: string;

  /**
   * The HTML content of the remark section.
   */
  detailHtml: string;
}

export const CompareRemark: React.FC<CompareRemarkProps> = ({
  title,
  detailHtml,
}: CompareRemarkProps) => {
  return (
    <Box
      css={{
        py: '$space-10',
        px: '$space-6',
      }}
      test={{
        dataTest: 'compare-remark',
      }}
    >
      <Text size="text-caption" font="bold" variant="text-gray-dark">
        {title}
      </Text>
      <Text
        size="text-caption"
        variant="text-gray-darkest"
        css={{ paddingTop: '$space-1' }}
        dangerouslySetInnerHTML={{
          __html: detailHtml,
        }}
      />
    </Box>
  );
};
CompareRemark.displayName = 'CompareRemark';
